export default __webpack_public_path__ + "static/media/clouds-sm.6be2a8d8.svg";